export default __webpack_public_path__ + "static/media/vLtc.a54c8302.svg";